import React, { Component } from "react";
import { Navbar } from "react-bootstrap";
import AdminNavbarLinks from "./AdminNavbarLinks.jsx";
import Cookies from 'universal-cookie';
import cookieManagement from '../../utilities/Cookie';
const cookies = new Cookies();

const hostname = window.location.hostname;
let clientSubDomain;

if (hostname === 'localhost' || hostname === '192.168.0.109') {
  clientSubDomain = 'product';
  cookies.set('clientSubDomain', 'product', { sameSite: 'lax', path: '/' });
} else {
  clientSubDomain = cookies.get('clientSubDomain') == undefined
    ? cookieManagement.setClientSubDomainToCookie()
    : cookies.get('clientSubDomain');
}

let logoName = clientSubDomain;
let logoVal = require('../../assets/img/clients/' + logoName + '/' + logoName + '.png');
let logoVal2 = '';

import(`../../assets/img/clients/${logoName}/${logoName}-description.png`)
  .then((module) => {
    logoVal2 = module.default;
  })
  .catch(() => {
    logoVal2 = '';
  });

class Header extends Component {

  constructor(props) {
    super(props);
    this.mobileSidebarToggle = this.mobileSidebarToggle.bind(this);
    this.state = {
      sidebarExists: false,
      sharedIconStyle : {
        marginTop: '10px',
        marginLeft: '18px',
        transform: 'translateX(20px)'
      }
    };
  }

  mobileSidebarToggle(e) {
  try{
    if (this.state.sidebarExists === false) {
      this.setState({
        sidebarExists: true
      });
    }
    e.preventDefault();
    document.documentElement.classList.toggle("nav-open");
    var node = document.createElement("div");
    node.id = "bodyClick";
    node.onclick = function () {
      this.parentElement.removeChild(this);
      document.documentElement.classList.toggle("nav-open");
    };
    document.body.appendChild(node);
   }catch (e) {
    this.props.setHasError({
      error: true,
      message: e
    })
  }
  }

  render() {
    const sharedIconStyle = this.state.sharedIconStyle
    return (
      <Navbar fluid>
        <Navbar.Header>
        {
            (logoName == 'valvoline') ? (
            <img style={{ width: '75px', marginTop: '10px' }} src={logoVal} alt="logo_image" />
            ) : (
              <img
              style={{
                width: logoName === 'vguard' ? '137px' : '100px',
                ...sharedIconStyle
              }}
              src={logoVal}
              alt="logo_image"
            /> )}
          <Navbar.Toggle onClick={this.mobileSidebarToggle} />
        </Navbar.Header>
        <Navbar.Collapse>
          <AdminNavbarLinks 
          onNavigate={() => this.props.onNavigate('search')}
          navigation={this.props.navigation}
            />
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default Header;
